import React, {useEffect, useState} from "react";

export default function Wishlist({elem}) {
    const wishlistUrl = elem.dataset.url || "";
    const [data, setData] = useState();

    useEffect(() => {
        window.Dibook.wishlist.fetchWishlistCount().then((response) => {
            setData(response.content);
        });

        const increaseWishlistCount = window.Dibook.wishlist.on("itemsAdded", ({type}) => {
            if (type === 'book') setData((val) => (val ?? 0) + 1);
        });

        const decreaseWishlistCount = window.Dibook.wishlist.on("itemsRemoved", ({type}) => {
            if (type === 'book') setData((val) => Math.max((val ?? 0) - 1, 0));
        });

        return () => {
            window.Dibook.wishlist.off("itemsAdded", increaseWishlistCount);
            window.Dibook.wishlist.off("itemsRemoved", decreaseWishlistCount);
        };
    }, []);

    return (
        <a
            href={wishlistUrl}
            className="header-cart-button"
            data-content={data ?? false}
            data-toggle="tooltip"
            title="Kívánságlista"
        >
            <img src="/images/icon/wishlist-2023.svg" alt="wishlist"/>
        </a>
    );
}
